import React from 'react';
import { AwardIcon } from 'lucide-react';
import { Section } from './Section';
import { ComparisonTable } from './ComparisonTable';
import { contrastRows } from '../data/tables';
const stats = ['300+ Pages', '6 Volumes', '30 conditions + 9 populations', 'Word-for-word scripts for 9 situations', 'One-page Quick Card per condition'];
const coverage = ['The Protocol', 'Lower Body', 'Spine', 'Upper Body', 'Special Populations', 'Scope, Consent & Referral'];
export function ProductPresentation() {
  return <Section background="paper" labelledBy="product-heading" data-id="element-246" data-mp="284ldccuns4lh">
      <div className="mx-auto max-w-3xl text-center" data-id="element-247" data-mp="1uermjozlfa94">
        <p className="inline-flex items-center gap-2 rounded-full bg-sage-soft px-4 py-2 font-sans text-[11px] font-semibold uppercase leading-tight tracking-[0.14em] text-sage" data-id="element-248" data-mp="1uc5hbw06d6u2">
          <AwardIcon className="h-3.5 w-3.5 shrink-0" strokeWidth={1.75} aria-hidden="true" data-id="element-249" data-mp="2m3usd974osnv" />
          The complete decision system for yoga teachers
        </p>

        <h2 id="product-heading" className="mt-7 font-serif text-[32px] font-semibold leading-[1.1] text-ink sm:text-4xl lg:text-[52px]" data-id="element-250" data-mp="2z9kahzokbgpm">
          Screen &amp; Adapt™ — Yoga Edition
        </h2>

        <p className="mt-4 font-sans text-[17px] leading-[1.6] text-ink sm:text-lg" data-id="element-251" data-mp="391pyyzflvg02">
          6 Volumes + 5 Bonuses — from the eight seconds after they tell you, to the class plan, to
          the referral that keeps the student.
        </p>

        <div className="mt-6 space-y-5 text-left font-sans text-[16px] leading-[1.65] text-ink-soft sm:text-center sm:text-[17px]" data-id="element-252" data-mp="3dz87ioppnt7j">
          <p data-id="element-253" data-mp="3rxy668s6i0y0">This is not a course. Not a CE weekend. Not another anatomy manual.</p>
          <p data-id="element-254" data-mp="3mzegpyedm70w">
            Pilots don't recite the flight manual before takeoff — they use a checklist. Emergency
            departments don't improvise the order patients are seen — they use triage. Not because
            they're inexperienced, but because they know memory under pressure is unreliable.
          </p>
          <p data-id="element-255" data-mp="3sp6b90mpsdpr">
            Screen &amp; Adapt™ is that checklist for the yoga room. It doesn't replace your
            training. It sits on top of it and makes it available at the exact moment you need it.
          </p>
        </div>
      </div>

      <ul className="mx-auto mt-10 grid max-w-4xl grid-cols-2 gap-x-6 gap-y-3 border-y border-sage/15 py-5 sm:mt-12 sm:flex sm:flex-wrap sm:items-center sm:justify-center" data-id="element-256" data-mp="5lrt6wb5pb2w">
        {stats.map(stat => <li key={stat} className="font-sans text-[13px] font-semibold text-ink sm:text-[14px]" data-id="element-257" data-mp="kgpp1z5ikioq">
            {stat}
          </li>)}
      </ul>

      <ul className="mt-8 flex flex-wrap justify-center gap-2" data-id="element-258" data-mp="p8phl6j989ba">
        {coverage.map(item => <li key={item} className="rounded-full bg-sage-soft px-3.5 py-2 font-sans text-[12px] font-medium text-sage sm:px-4 sm:text-[13px]" data-id="element-259" data-mp="t7q1ksdgxhzv">
            {item}
          </li>)}
      </ul>

      <ComparisonTable className="mx-auto mt-12 max-w-3xl sm:mt-14" rows={contrastRows} leftLabel="A course or training" rightLabel="This system" data-id="element-260" data-mp="134umkovkv7f3" />
    </Section>;
}